import React from 'react';
import AResult from 'antd-mobile/lib/result';



export default class Result extends AResult {}